import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=5f97225d"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=5f97225d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports